// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TjztC","comment":"styles_comment__1C6g3"};